<template>
    <div class="product-resource">
        <el-table :data="resourceList" style="width: 100%">
            <el-table-column
                v-for="(column, index) in columnList"
                :key="index"
                :label="column.label"
                :prop="column.prop"
                :width="column.width">
                <template slot-scope="{ row }">
                    {{ column.prop ? (row[column.prop] || '--') : '' }}
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                :width="250"
                prop="operat">
                <div class="operat-wrap" slot-scope="{ row }">
                    <el-button
                        class="operat-item"
                        type="text"
                        :disabled="!['png', 'video', 'pdf'].includes(row.file_type)"
                        @click="handlePreivew(row)">
                        <i class="icon-smart-view"></i>预览
                    </el-button>
                    <el-button
                        class="operat-item"
                        type="text"
                        :disabled="row.file_type === 'png'"
                        @click="handleDownload(row)">
                        <i class="icon-xiazai"></i>下载
                    </el-button>
                </div>
            </el-table-column>
        </el-table>
        <el-dialog
            :visible.sync="isShow"
            center
            :close-on-click-modal="false"
            :destroy-on-close="true"
            custom-class="pro-video-dialog"
            @close="handleClose">
            <video width="100%" :src="videoUrl" autoplay controls>
                抱歉，您的浏览器不支持内嵌视频，不过不用担心，你可以 <a :href="videoUrl">下载</a>
                并用你喜欢的播放器观看!
            </video>
        </el-dialog>
    </div>
</template>

<script>
import bus from '@/js/bus.js'
export default {
    props: {
        appDetail: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        const columnList = [
            {
                label: '',
                prop: '',
                width: 20
            }, {
                label: '文件名',
                prop: 'file_name'
            }, {
                label: '上传时间',
                prop: 'upload_time',
                width: 250
            }, {
                label: '大小',
                prop: 'file_size',
                width: 200
            }
        ]
        return {
            resourceList: [],
            columnList,
            isShow: false,
            videoUrl: '',
            imgUrl: ''
        }
    },
    watch: {
        appDetail: {
            handler (val) {
                if (!Object.keys(val).length) return
                this.resourceList = val && val.resources.map(item => {
                    this.$set(item, 'isLoading', false)
                    return item
                })
            },
            immediate: true
        }
    },
    methods: {
        // 预览
        handlePreivew (row) {
            const { access_url: url, file_type: type } = row
            if (type === 'video') {
                this.videoUrl = url
                this.isShow = true
            } else if (['pdf', 'png'].includes(type)) {
                window.open(url, '_blank')
            }
        },
        // 下载
        async handleDownload (row) {
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup', 'downLoad');
                return;
            }
            if (row.isLoading) return
            const { access_url: url, file_type: type, file_name } = row
            row.isLoading = true
            if (type === 'video') {
                window.open(url, '_blank')
            } else {
                let fileName = file_name
                // 判断文件名是否为 `.${type}` 结尾的
                const lastN = file_name.slice(-(type.length + 1))
                if (lastN !== `.${type}`) {
                    fileName += type
                }
                await this.fileLinkToStreamDownload(decodeURI(url), fileName, type)
            }
            row.isLoading = false
        },
        fileLinkToStreamDownload (url, fileName, type) {
            let xhr = new XMLHttpRequest()
            xhr.open('get', url, true)
            xhr.setRequestHeader('Content-Type', `application/${type}`)
            xhr.responseType = "blob"
            xhr.onload = function () {
                if (this.status == 200) {
                    //接受二进制文件流
                    const blob = this.response
                    const blobUrl = window.URL.createObjectURL(blob)
                    // 这里的文件名根据实际情况从响应头或者url里获取
                    const a = document.createElement('a')
                    a.href = blobUrl
                    a.download = fileName
                    document.body.appendChild(a)
                    a.click()
                    window.URL.revokeObjectURL(blobUrl)
                    document.body.removeChild(a)
                }
            }
            xhr.send()
        },
        // 关闭弹框
        handleClose () {
            this.videoUrl = ''
            this.imgUrl = ''
        }
    }
}
</script>


<style lang="scss" scoped>
    .operat-wrap {
        display: flex;
        align-items: center;
        .operat-item {
            font-size: 12px;
            color: #606266;
            i {
                position: relative;
                top: 2px;
                margin-right: 5px;
            }
            &:first-child {
                margin-right: 10px;
            }
            &:hover {
                color: #3a84ff;
                i:before {
                    color: #3a84ff;
                }
            }
            &.is-disabled {
                color: #c0c4cc;
                i:before {
                    color: #c0c4cc;
                }
            }
        }
    }
    
</style>
<style lang="scss">
    .product-resource .el-table {
        .el-table__header {
            th {
                background-color: #f0f1f5;
                color: #63656e;
                font-size: 12px;
            }
        }
    }
    .pro-video-dialog {
        .el-dialog__header {
            padding: 0;
            .el-dialog__headerbtn {
                top: 10px;
                right: 16px;
                font-size: 18px;
                z-index: 99;
                &:hover .el-icon-close {
                    color: #3a84ff;
                }
            }
        }
        .el-dialog__body {
            padding: 0;
            height: 500px;
            video {
                min-height: 500px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// information.vue?92216114